module.exports = __webpack_public_path__ + "img/iconfuzhixinxi.a8c060fc.png";